<ng-container *ngIf="mode$ | async as mode">
  <div class="fx--h fx--mt-md">
    <div class="searchbox fx--col-6">
      <input
        #searchInput
        class=""
        [formControl]="searchControl"
        type="text"
        autocomplete="no-autofill"
        [placeholder]="'Search property name, address, market, submarket'"
        (keyup.enter)="search(searchControl.value)"
      />
      <mat-icon id="e2e-search-close" (click)="clear()" *ngIf="searchInput.value" class="clear">close</mat-icon>
      <mat-icon id="e2e-search-search" (click)="search(searchControl.value)" class="search">search</mat-icon>
    </div>
  </div>
  <div class="fx--h fx--mt-sm table-container">
    <ng-template #resultsCount>
      <cbre-table-title title="Property List" [count]="selectionHandlerSrv?.totalRecordCount"></cbre-table-title>
    </ng-template>

    <ng-template #tableActions>
      <div class="fx--h fx--mb-x">
        <div
          [matTooltip]="
            canUserAccess
              ? mode == MODE.Read
                ? 'Select Records to Remove'
                : editModeTooltip
              : 'View Only access. Cannot add or remove Records.'
          "
          matTooltipPosition="above"
          matTooltipClass="tooltip-action-icon"
        >
          <a
            [attr.disabled]="
              !canUserAccess || mode == MODE.Edit || selectionHandlerSrv.selectedItems?.length == 0 ? true : null
            "
            id="e2e-delete-entity"
            class="action-buttons fx--mr-xs"
            (click)="mode == MODE.Read ? deleteSelectedProperties() : $event.preventDefault()"
          >
            <mat-icon svgIcon="trash-icon"></mat-icon>
          </a>
        </div>
        <div
          [matTooltip]="
            canUserAccess
              ? mode == MODE.Read
                ? 'Add Record to Property Set'
                : editModeTooltip
              : 'View Only access. Cannot add or remove Records.'
          "
          matTooltipPosition="above"
          matTooltipClass="tooltip-action-icon"
        >
          <a
            [attr.disabled]="!canUserAccess || mode == MODE.Edit ? true : null"
            id="e2e-create-entity"
            class="action-buttons fx--pb-xs"
            [routerLink]="['create']"
            [matMenuTriggerFor]="addNewProperty"
          >
            <mat-icon svgIcon="add-icon"></mat-icon>
          </a>
        </div>
        <mat-menu #addNewProperty="matMenu">
          <div mat-menu-item (click)="$event.stopPropagation()">
            <miq-search
              #searchComponent
              [userId]="userId"
              entity="property"
              [filters]="[]"
              (newRecord)="trigger.closeMenu(); onPropertySelected($event)"
              class="newproperty-search"
              *ngIf="trigger?.['_menuOpen']"
            >
            </miq-search>
          </div>
        </mat-menu>
      </div>
    </ng-template>

    <ng-template #cellRendererTpl let-row="row" let-column="column">
      <span>{{ row | dataColumnFormatter: column }} </span>
    </ng-template>

    <!-- TABLE -->
    <div id="property-set-record">
      <cbre-table
        [tableId]="propertySetRecordId"
        [selectionMode]="canUserAccess ? 'multi' : null"
        [elements]="selectionHandlerSrv?.dataSource?.data"
        [toolboxLeftTpl]="resultsCount"
        [columns]="columns"
        [cellRendererTpl]="cellRendererTpl"
        [toolboxRightTpl]="tableActions"
        [pageSizeOptions]="[20, 50, 100]"
        [totalCount]="selectionHandlerSrv?.totalRecordCount > 10000 ? 10000 : selectionHandlerSrv?.totalRecordCount"
        (sortChange)="onSortChange($event)"
        [stickyHeader]="true"
        [showFirstLastButtons]="true"
        (pageChange)="onPageChange($event)"
      ></cbre-table>
    </div>
  </div>
</ng-container>
